import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from '@angular/forms';
import { ClientField } from '../../domain/models';

export class YourEducationForm {
    private static yearRegExp: RegExp = /^[0-9]{4}$/;

    private static _fb: UntypedFormBuilder;

    static initialize(fb: UntypedFormBuilder) {
        this._fb = fb;
        return fb.group({
            applicationId: [undefined, Validators.required],
            is16or17YearsOld: [false]
        });
    }

    static setFields(fields: ClientField[], formGroup: UntypedFormGroup): void {
        fields.forEach((field) => {
            switch (field.fieldName) {
                case 'HighestLevelOfEducation':
                    formGroup.addControl(
                        'highestLevelOfEducationSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('highestLevelOfEducationSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'HighestLevelOfEducationAlt':
                    formGroup.addControl(
                        'highestLevelOfEducationAltSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('highestLevelOfEducationAltSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'LastSchoolYear':
                    formGroup.addControl(
                        'lastSchoolYear',
                        this._fb.control(undefined, [
                            Validators.pattern(this.yearRegExp),
                            this.futureYearValidator(new Date().getFullYear())
                        ])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('lastSchoolYear')
                            ?.addValidators([Validators.required]);
                    break;
                case 'LastSchoolAttended':
                    formGroup.addControl(
                        'lastSchoolAttended',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('lastSchoolAttended')
                            ?.addValidators([Validators.required]);
                    break;
                case 'LastSchoolLocation':
                    formGroup.addControl(
                        'lastSchoolLocation',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('lastSchoolLocation')
                            ?.addValidators([Validators.required]);
                    break;
                case 'LastSchoolReasonForLeaving':
                    formGroup.addControl(
                        'lastSchoolReasonForLeaving',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('lastSchoolReasonForLeaving')
                            ?.addValidators([Validators.required]);
                    break;
                case 'SchoolingInUS':
                    formGroup.addControl(
                        'schoolingInUSSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('schoolingInUSSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'PrimaryLanguage':
                    formGroup.addControl(
                        'primaryLanguageSelectionId',
                        this._fb.control(undefined)
                    );
                    formGroup.addControl(
                        'primaryLanguageComment',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('primaryLanguageSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                // case 'PrimaryLanguageComment':
                //     if (field.isRequired)
                //         formGroup
                //             ?.get('primaryLanguageComment')
                //             ?.addValidators([Validators.required]);
                //     break;
                case 'Programs':
                    formGroup.addControl(
                        'programSelectionIds',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('programSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ProgramSingleSelect':
                    formGroup.addControl(
                        'programSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('programSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReasonsForAttending':
                    formGroup.addControl(
                        'reasonsForAttendingSelectionIds',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('reasonsForAttendingSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReasonForAttendingOther':
                    formGroup.addControl(
                        'reasonForAttendingOther',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('reasonForAttendingOther')
                            ?.addValidators([Validators.required]);
                    break;
                case 'DesiredSchedule':
                    formGroup.addControl(
                        'desiredScheduleIds',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('desiredScheduleIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Goals':
                    formGroup.addControl(
                        'goalsSelectionIds',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('goalsSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ApplicationLocation':
                    formGroup.addControl(
                        'applicationLocationSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('applicationLocationSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReasonMinorAttendingAdultEducation':
                    formGroup.addControl(
                        'reasonMinorAttendingAdultEducationSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get(
                                'reasonMinorAttendingAdultEducationSelectionId'
                            )
                            ?.addValidators([Validators.required]);
                    break;
                case 'LastSchoolAttendedSelect':
                    formGroup.addControl(
                        'lastSchoolAttendedSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('lastSchoolAttendedSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReasonLeftSchool':
                    formGroup.addControl(
                        'reasonLeftSchoolSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('reasonLeftSchoolSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'SchoolStatusAtEntry':
                    formGroup.addControl(
                        'schoolStatusAtEntrySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('schoolStatusAtEntrySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
            }
        });
    }
    private static futureYearValidator(futureYear: Number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value <= futureYear ? null : { futureYear: true };
        };
    }
}
